import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../../context/AdminAuthContext';
import { Shield, Lock, Mail, AlertCircle } from 'lucide-react';
import './AdminLogin.css';

function AdminLogin() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAdminAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await login(email, password);
            navigate('/admin/dashboard');
        } catch (err) {
            setError(err.response?.data?.error || 'Invalid admin credentials');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-login-container">
            <div className="admin-login-card">
                <div className="admin-login-header">
                    <div className="admin-login-logo">
                        <Shield size={40} color="#38bdf8" />
                    </div>
                    <h1>ROVA Control Panel</h1>
                    <p>Administrative Access Only</p>
                </div>

                <form className="admin-login-form" onSubmit={handleSubmit}>
                    {error && (
                        <div className="admin-login-error">
                            <AlertCircle size={18} />
                            <span>{error}</span>
                        </div>
                    )}

                    <div className="admin-form-group">
                        <label htmlFor="email">Email Address</label>
                        <div className="admin-input-wrapper">
                            <Mail size={18} className="admin-input-icon" />
                            <input
                                id="email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="admin@rova.ai"
                                required
                            />
                        </div>
                    </div>

                    <div className="admin-form-group">
                        <label htmlFor="password">Password</label>
                        <div className="admin-input-wrapper">
                            <Lock size={18} className="admin-input-icon" />
                            <input
                                id="password"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="••••••••"
                                required
                            />
                        </div>
                    </div>

                    <button
                        type="submit"
                        className="admin-login-btn"
                        disabled={loading}
                    >
                        {loading ? 'Authenticating...' : 'Sign In to Admin'}
                    </button>
                </form>

                <div className="admin-login-footer">
                    <p>&copy; 2026 ROVA AI. All rights reserved.</p>
                </div>
            </div>
        </div>
    );
}

export default AdminLogin;
